<div class="avatar-container">
  <a class="avatar-arrow left" [class.disabled]="true" href="#" (click)="skipAvatar($event, 'left')"
     title="Click to shift the list of avatars to the left"></a>

  <ul class="avatar-wrapper">
    @for (item of avatars(); track item; let i = $index) {
    <li class="avatar animated" #avatar [class.active]="avatarSelected() === item" (click)="pickAvatar(i)">
      <img [src]="item" [alt]="i18n.str('challengeu.main_avatar', 'Avatar')()"
           [title]="i18n.str('challengeu.main_avatar', 'Avatar' )()" />
    </li>
    }
  </ul>

  <a class="avatar-arrow right" [class.disabled]="true" href="#" (click)="skipAvatar($event, 'right')"
     title="Click to shift the list of avatars to the right"></a>
  @if(showSaveCancelBar()) {
  <div class="avatar-change-actions">
    <a href="#" title="SAVE" (click)="saveNewAvatar($event)">SAVE</a>&nbsp;
    <a href="#" title="CANCEL" (click)="cancelAvatarChange($event)">CANCEL</a>
  </div>
  }
</div>
